<template>
  <div v-wechat-title="title" style="float:left;width: 100%;">
    <div>
        <list-view :showSequence="true" ref="supplies-list"
            :datalist="datalist"
            :columns="columnList"
            @extrabutton-click="ExtraButtonClick"
            :tableHeight="tableHeight"
            >
        </list-view>
        <CloseButton type="confirm" @confirm="saveItems" :data="data" :msg="msg"> </CloseButton>
   </div>
  </div>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `TakeHoliday`,
    props: {

    },
    data() {
        return {
            title: `补休`,
            token: this.$route.query.token,
            surgeryId: this.$route.query.surgery_id,
            surgeryInfo: null,
            workers: [],
            rdate: this.$moment().add(1, `days`).format(`YYYY-MM-DD`),
            data: {},
            msg: `closeWindow`,
            datalist: []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadSurgeryInfo()
        this.loadSurgeryHoliday()
    },
    computed: {
        ...mapGetters([`sysuser/workers_by_duty`, `sys_enums`, `screenHeight`, `currentUser`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 120) || 0
        },
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        columnList() {
            return [{
                type: `string`,
                prop: `___index`,
                label: `unique`,
                isKey: true
            },
            {
                type: `string`,
                prop: `id`,
                label: `编号`
            },
            {
                type: `select`,
                prop: `dic_worker_id`,
                label: `补休人员`,
                isListable: true,
                readonly: false,
                options: this.workers,
                change: (that, { row, index }) => {
                    if (row.is_empty) {
                        this.$set(row, `is_empty`, false)
                        this.datalist.push({ ___index: _.now(), is_empty: true, holiday_date: this.$moment().format(`YYYY/MM/DD 00:00:00`) })
                    }
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `date`,
                prop: `holiday_date`,
                label: `补休日期`,
                isListable: true,
                readonly: false,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `100`,
                isListable: true,
                readonly: false,
                options: (that, { row }) => {
                    return row.is_empty
                        ? []
                        : [
                            {
                                class: `is-plain is-circle`,
                                label: ``,
                                icon: `el-icon-close`,
                                type: `danger`,
                                emit: `removeItem`,
                                permission: `default`
                            }
                        ]
                }
            }
            ]
        }
    },
    methods: {
        loadSurgeryInfo() {
            if (!this.surgeryId) return
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                req.then(data => {
                    if (data.fact_surgeon) {
                        this.workers.push(data.fact_surgeon)
                    }
                    if (data.fact_anes_doctor) {
                        this.workers.push(data.fact_anes_doctor)
                    }
                    if (data.fact_surgeon_assistants && data.fact_surgeon_assistants.length > 0) {
                        this.workers = this.workers.concat(data.fact_surgeon_assistants)
                    }
                    if (data.fact_anes_assistants && data.fact_anes_assistants.length > 0) {
                        this.workers = this.workers.concat(data.fact_anes_assistants)
                    }
                    if (data.fact_circuit_nurse && data.fact_circuit_nurse.length > 0) {
                        this.workers = this.workers.concat(data.fact_circuit_nurse)
                    }
                    if (data.fact_equipment_nurse && data.fact_equipment_nurse.length > 0) {
                        this.workers = this.workers.concat(data.fact_equipment_nurse)
                    }

                    this.workers = _.uniqWith(this.workers, (worker1, worker2) => {
                        return worker1.value === worker2.value
                    })

                    resolve(this.workers)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadSurgeryHoliday() {
            if (!this.surgeryId) return
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Holiday/GetHolidayBySurgeryId?surgeryId=${this.surgeryId}`)
                req.then(data => {
                    if (data && data.length > 0) {
                        this.datalist = data.map(i => {
                            i.holiday_date = this.$moment(i.holiday_date).format(`YYYY/MM/DD 00:00:00`)
                            return i
                        })
                    }
                    this.datalist.push({ ___index: _.now(), is_empty: true, holiday_date: this.$moment().format(`YYYY/MM/DD 00:00:00`) })
                    resolve(this.datalist)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        saveItems() {
            let that = this
            return new Promise((resolve, reject) => {
                try {
                    var pddata = _.filter(this.datalist, d => !d.is_empty)
                    pddata.forEach(d => {
                        if (d.dic_worker_id == null) {
                            this.$message.error(`请选择补休人员！`)
                            throw new Error(`EndIterative`)
                        }
                        if (d.holiday_date == null) {
                            this.$message.error(`请选择补休日期！`)
                            throw new Error(`EndIterative`)
                        }
                    })

                    let r = _.groupBy(pddata, d => d.dic_worker_id)
                    let valid = true
                    _.forEach(r, (g) => {
                        if (g.length > 1 && valid) {
                            this.$message.warning(`补休人员重复`)
                            valid = false
                        }
                    })
                    if (!valid) { reject(); return }
                } catch (e) {
                    if (e.message != `EndIterative`) throw e
                    return
                }
                let data1 = this.getAdd()
                let data2 = this.getEdit()
                let req1 = this.myaxios.post(`/api/AcisSystem/Holiday/PostMany`, data1)
                let req2 = this.myaxios.put(`/api/AcisSystem/Holiday/PutHolidayMany`, data2)
                this.myaxios
                    .all(req1, req2)
                    .then(([res1, res2]) => {
                        that.data = { surgeryId: this.surgeryId }
                        that.sendMessage()
                    })
                    .catch(e => {
                        console.log(e)
                        reject(e)
                    })
            })
        },
        getAdd() {
            let data1 = _.map(
                _.filter(this.datalist, d => d.dic_worker_id && !d.id),
                d => {
                    return {
                        id: d.id,
                        biz_surgery_info_id: this.surgeryId,
                        dic_worker_id: d.dic_worker_id,
                        holiday_date: d.holiday_date
                    }
                }
            )
            return data1
        },
        getEdit() {
            let data2 = _.map(
                _.filter(this.datalist, d => d.dic_worker_id && d.id > 0),
                d => {
                    return {
                        id: d.id,
                        biz_surgery_info_id: this.surgeryId,
                        dic_worker_id: d.dic_worker_id,
                        holiday_date: d.holiday_date
                    }
                }
            )
            return data2
        },
        removeItem({ row, index }) {
            if (row.id > 0) {
                let req = this.myaxios.delete(`/api/AcisSystem/Holiday/Delete/${row.id}`)
                req.then(data => {
                    this.datalist.splice(index, 1)
                })
            } else {
                this.datalist.splice(index, 1)
            }
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/TakeHoliday.vue